module.exports = __webpack_public_path__ + "img/reason-field-example.1e5ca934.png";